module.exports = __webpack_public_path__ + "img/clipboard.0a4bae8f.svg";